import React, { ReactNode } from 'react';
import './style.css';

/**
 * Props for the CustomButtonGroup component.
 */
interface CustomButtonGroupProps {
  /** The child elements (buttons) to be rendered inside the button group. */
  children: ReactNode;
}

/**
 * A wrapper component for grouping buttons together with a consistent style.
 *
 * @param {CustomButtonGroupProps} props - The component props.
 * @returns {JSX.Element} The rendered CustomButtonGroup component.
 */
const CustomButtonGroup: React.FC<CustomButtonGroupProps> = ({ children }) => {
  return (
    <div id="buttonGroupWrapper" className="buttonGroupWrapper">
      <div className="buttonGroupContent">{children}</div>
    </div>
  );
};

export default CustomButtonGroup;
